import Vue from 'vue';
import vuetify from './plugins/vuetify'
import App from './App.vue';
import router from './router/router';
import './amplify/amplify';
import './maps/googleMaps';
import './vuelidate/vuelidate'
import store from './store/store';
import './apexcharts/apexchart'
import './axios/axios'
import  './mask/Mask'
import './logger/Log'
import './filters/Filters'
//Vue.config.productionTip = false

new Vue({
  render: h => h(App),
    router,
    store,
    vuetify
}).$mount('#app')